import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';
import { Example as VGraphExample } from '../sites/vgraph/views/example';
import { Demo as VGraphDemo } from '../sites/vgraph/views/demo';

const VGraph = lazy(async () => {
  const { VGraph } = await import('../sites/vgraph');
  return { default: VGraph };
});
const VGraphGuide = lazy(async () => {
  const { Guide } = await import('../sites/vgraph/views/guide');
  return { default: Guide };
});
const VGraphChangelog = lazy(async () => {
  const { Changelog } = await import('../sites/vgraph/views/changelog');
  return { default: Changelog };
});

export const vgraphRoutes: RouteObject[] = [
  {
    path: '/vgraph',
    element: (
      <Suspense>
        <VGraph />
      </Suspense>
    ),
  },
  {
    path: '/vgraph/example',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: <VGraphExample />,
  },
  {
    path: '/vgraph/demo',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: <VGraphDemo />,
    children: [
      {
        path: '*',
        element: <VGraphDemo />,
      },
    ],
  },
  {
    path: '/vgraph/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VGraphGuide />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        loader: loaders.guideLoader,
        shouldRevalidate: () => true,
        element: (
          <Suspense>
            <VGraphGuide />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vgraph/changelog',
    loader: loaders.changelogLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VGraphChangelog />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        loader: loaders.changelogLoader,
        shouldRevalidate: () => true,
        element: (
          <Suspense>
            <VGraphChangelog />
          </Suspense>
        ),
      },
    ],
  },
];
